<template>
  <div class="upload-box">
    <progress-bar v-show='showProgressBar' ref='progressBar' :val='progressVal' :text='progressText' class="upload-progress"></progress-bar>

  </div>
</template>


<script>
  import ProgressBar from 'vue-simple-progress';
  import { EventBus } from '../../../../../plugins/eventBus';
  import ShowProgress from '@/components/mmlconfig/respItem/ShowProgress';
  import packageParams from '@/components/mmlconfig/mixins/packageParams';
  import mmlSocket from '@/plugins/stompSock';
  import { createNamespacedHelpers } from 'vuex';
  const { mapGetters, mapMutations } = createNamespacedHelpers('mmlconfig');
  export default {
    name: 'recoverDialog',
    props: [
      'selectedId'
    ],
    components: {
      ProgressBar,
      ShowProgress
    },
    mixins: [packageParams],
    data() {
      return {
        extensions: '.tar.gz,.zip,.pkg',
        showProgressBar: false,
        progressVal: 10,
        progressText: '10%',
        versionShow: false,
        deliverType: [
          {text: 'Native', value: 0},
          {text: 'Image', value: 1},
          {text: 'Helm', value: 2},
          {text: 'VM', value: 3}
        ],
        versionSource: [],
        brokenFlag:0,
        payload: [
          { topic: '/user/#/MMLServer', clientId: this.getUserId(), callback: this.mmlWebsocketLisener }
        ],
      }
    },
    computed :{
       ...mapGetters(['currentNe']),
    },

    methods: {
      recoverBySelected(cfgExt){
        this.showProgressBar = true;
        console.log('cfgExt=:'+cfgExt);
        const deviceSyncCfgUrl = '/lte/ems/config/mml/deviceASyncCfgRequest';
          const deviceSyncCfgParam = {
            url: cfgExt.url,
            configExportId: cfgExt.id,
            equipmentId: cfgExt.equipmentId,
            channelId: this.getUserId()
          };
         this.$axios.post(deviceSyncCfgUrl, deviceSyncCfgParam, {timeout: 60 * 5 * 1000}).then(res => {
            console.log(res.data)
            if(res.data.errorCode == 'SUCCESS'){
               this.progressVal = 50;
               this.progressText = 50 + '%';
            }else{
               this.progressVal = 100;
               this.progressText = this.$t('MML.recoverFail');
            }
         });
      },
      mmlWebsocketLisener(wsMessage) {
          console.log("mmlWebsocketLisener",wsMessage);
          const message = JSON.parse(wsMessage.body);
          console.log("dialog_message: "+ message.data);
          if( '3' == message.cmd){
            this.progressVal = 100;
            this.progressText = this.$t('MML.exeTimeOut');
          }
          else  if( '2' == message.cmd ){
            this.progressVal += message.data;
            this.progressText = this.progressVal+'%';
          }
          else if('5' == message.cmd){
            this.progressVal = 100;
            this.progressText = this.$t('MML.exeSuccess')
          }
        }
    },
    destroyed() {
      this.brokenFlag = 1;
    },
    beforeDestroy(){
      mmlSocket.stopReceiveTopicMsg(this.getUserId(), '/user/#/MMLServer');
    },
    mounted() {
        mmlSocket.init(this.payload);
        this.recoverBySelected();
    }
  }
</script>
